import 'dotenv/config'

const env = process.env.REACT_APP_ENV || "development"

const config = {
    env, ...require("./env/" + env)
}

console.log(env);
export default config;